import { AsyncStoreItem } from '@lib/store';
import { GetListResponse } from 'src/sdk-servicing';

/**
 * BusinessTripGetList model
 */
export interface BusinessTripGetListModel {
  model: GetListResponse | null;
}

/**
 * GetListResponse model details
 */
export interface BusinessTripGetListStateDetails extends AsyncStoreItem {}

/**
 * BusinessTripGetList store state
 */
export interface BusinessTripGetListState extends BusinessTripGetListStateDetails, BusinessTripGetListModel {}

/**
 * Name of the BusinessTripGetList Store
 */
export const BUSINESS_TRIP_GET_LIST_STORE_NAME = 'businessTripGetList';

/**
 * BusinessTripGetList Store Interface
 */
export interface BusinessTripGetListStore {
  /** BusinessTripGetList state */
  [BUSINESS_TRIP_GET_LIST_STORE_NAME]: BusinessTripGetListState;
}
